import {
  registerDecorator,
  type ValidationArguments,
  type ValidationOptions,
} from 'class-validator';
import { isValidCap } from './partita-iva';

/** Validates an Italian CAP (postal code): exactly 5 digits. */
export function IsCap(validationOptions?: ValidationOptions) {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name: 'isCap',
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown, _args: ValidationArguments) {
          return typeof value === 'string' && isValidCap(value);
        },
        defaultMessage() {
          return 'CAP non valido';
        },
      },
    });
  };
}
